import Client from "./Client";
import Campaign from "Class/Campaign";
import { AnyObject } from "types";
import { isSuper } from "Services/Auth";

const resource = "/campaigns";

export default class CampaignService {
  public static async getSurveys(
    campaignId: number,
    page: number,
    size: number
  ): Promise<AnyObject> {
    const { data } = await Client.get(
      `${resource}/${campaignId}/surveys?page=${page}&page_size=${size}`
    );
    return data;
  }

  public static async getCampaigns(
    page: number,
    size: number,
    companyId: number,
    adminId: number
  ): Promise<AnyObject> {
    let url = `${resource}?page=${page}&page_size=${size}`;
    if (companyId) url += `&companyId=${companyId}`;
    if (adminId) url += `&adminId=${adminId}`;
    const { data } = await Client.get(url);
    return data;
  }

  public static async getMembers(
    campaignId: number,
    page: number,
    size: number
  ): Promise<AnyObject> {
    const { data } = await Client.get(
      `${resource}/${campaignId}/members?page=${page}&page_size=${size}`
    );
    return data;
  }

  public static async addMembers(
    campaignId: number,
    userIds: Array<number>
  ): Promise<AnyObject> {
    const { data } = await Client.post(
      `${resource}/${campaignId}/add_members`,
      {
        members: userIds,
      }
    );
    return data;
  }
  public static async getNonMembers(campaignId: number): Promise<AnyObject> {
    const { data } = await Client.get(`${resource}/${campaignId}/non_members`);
    return data;
  }

  public static async getCampaign(campaignId: number): Promise<Campaign> {
    const { data } = await Client.get(`${resource}/${campaignId}`);
    return new Campaign(data.data);
  }

  public static async saveCampaign(campaign: Campaign): Promise<void> {
    if (campaign.id === 0) {
      await Client.post(`${resource}`, campaign.asJSON());
    } else {
      await Client.put(`${resource}/${campaign.id}`, campaign.asJSON());
      if (isSuper()) {
        await Client.put(`${resource}/update_company`, {
          campaignId: campaign.id,
          companyId: campaign.company.id,
        });
      }
    }
  }

  public static async removeCampaign(campaignId: number): Promise<void> {
    await Client.delete(`${resource}/${campaignId}`);
  }
}
